var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99985 0.751953C6.19017 0.751953 6.36399 0.860003 6.44822 1.03067L7.87483 3.92134L11.0646 4.38362C11.253 4.41093 11.4096 4.54291 11.4684 4.72402C11.5272 4.90513 11.4781 5.10392 11.3416 5.23674L9.03014 7.48673L9.57515 10.6639C9.60735 10.8516 9.53015 11.0413 9.37606 11.1531C9.22196 11.2649 9.01771 11.2796 8.84926 11.1908L6.00309 9.69099L3.15003 11.191C2.98157 11.2796 2.77743 11.2648 2.62346 11.153C2.46948 11.0411 2.39237 10.8515 2.42455 10.6639L2.96957 7.48673L0.658095 5.23674C0.521646 5.10392 0.472484 4.90513 0.531297 4.72402C0.59011 4.54291 0.746687 4.41093 0.935136 4.38362L4.12487 3.92134L5.55148 1.03067C5.63571 0.860003 5.80953 0.751953 5.99985 0.751953Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorites);
export default __webpack_public_path__ + "static/media/favorites.fb8d83064412f8afd6788638585ce0fa.svg";
export { ForwardRef as ReactComponent };